const styleVars = {
  grey1: '#ececec',
}

export default styleVars;